import React from 'react';
import { makeStyles } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import keyBy from 'lodash/keyBy';
import WealthEditGuesser from '../../base/components/guesser/wealth-edit.guesser';
import GroupForm from './components/GroupForm';
import { INVOICE_SERVICE } from '../../constant/invoice';
import { getAddressLines } from './group.show';
import { useTransformGroupData } from './components/utils';
import { getBackofficeEnv } from '../../services/util';

const GroupEdit = (props) => {
  const classes = useStyles();
  const t = useTranslate();
  const transformGroupData = useTransformGroupData();
  const { DEFAULT_OPENING_BALANCE_TIME } = getBackofficeEnv();

  const transform = (data) => transformGroupData(data, true);

  return (
    <>
      <WealthEditGuesser
        {...props}
        transform={transform}
        custom
        className={classes.wrapper}
        confirmDialogInfo={(values) =>
          !values.enabled
            ? {
                content: t('resources.group.disableGroupWarning'),
              }
            : {}
        }
        initialValues={(record) => {
          const royalty = keyBy(record?.royalty || [], 'invoiceService');
          return {
            companyAddress: getAddressLines(record?.invoiceProfile || {}),
            monthlyRoyalty: royalty[INVOICE_SERVICE.MONTHLY_GGR]?.value,
            mktRoyalty: royalty[INVOICE_SERVICE.MKT_FREE_SPIN]?.value,
            openingBalanceStartTime: (record?.openingBalanceTime ?? DEFAULT_OPENING_BALANCE_TIME) || undefined,
          };
        }}
      >
        <GroupForm isEdit />
      </WealthEditGuesser>
    </>
  );
};

export default GroupEdit;

const useStyles = makeStyles({
  wrapper: {
    maxWidth: '960px',
    width: '100%',
    margin: 'auto',
  },
});
